import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "A aplicação dói?",
    a: "O desconforto é mínimo. São utilizadas agulhas muito finas e o procedimento é rápido. A maior parte das pacientes relata sensação semelhante a pequenas picadas e tolera o procedimento muito bem.",
  },
  {
    q: "Quanto tempo dura o procedimento?",
    a: "A aplicação leva, em média, entre 15 e 30 minutos, dependendo da indicação e do número de pontos. Você sai da consulta e retoma sua rotina normalmente.",
  },
  {
    q: "Em quanto tempo aparecem os resultados?",
    a: "Os primeiros efeitos costumam ser percebidos entre 5 e 14 dias após a aplicação, com benefício máximo geralmente entre 3 e 4 semanas. A duração varia conforme o caso.",
  },
  {
    q: "Quem pode realizar o tratamento?",
    a: "O tratamento deve ser indicado e conduzido por profissional médico habilitado, após avaliação clínica criteriosa que confirme indicação e segurança para o seu caso.",
  },
  {
    q: "Preciso de avaliação antes?",
    a: "Sim. A avaliação prévia é essencial para confirmar diagnóstico, definir o protocolo adequado, esclarecer dúvidas e personalizar o plano de tratamento conforme a sua história clínica.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <div className="text-center">
          <p className="overline text-[#D4AF37] mb-5">Tire suas dúvidas</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0A2540] leading-tight tracking-tight">
            Perguntas frequentes
          </h2>
          <p className="mt-6 text-[#1A1A1A]/70 leading-relaxed">
            Reunimos as respostas para as dúvidas mais comuns sobre o tratamento
            com Toxina Botulínica para dor.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="border-b border-[#E9ECEF]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif-display text-xl sm:text-2xl text-[#0A2540] hover:no-underline hover:text-[#0D3B66] py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#1A1A1A]/75 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
